<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'base-button',
  props: {
    look: {
      type: String,
      default: '',
      validator: (v: string) => !v || /outlined/.test(v),
    },
  },
})
</script>

<template>
  <button
    :class="[
      look === 'outlined' &&
        'border-text border-2 text-default hover:opacity-80 disabled:opacity-40',
      !look &&
        'bg-primary hover:opacity-90 disabled:opacity-40 border border-transparent text-white',
    ]"
    class="inline-flex justify-center items-center px-4 font-medium text-center rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 shadow-sm h-button focus:ring-primary"
    type="button"
    v-bind="$attrs"
  >
    <slot />
  </button>
</template>
